var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-dropdown',{staticClass:"create-section-menu",attrs:{"right":"","offset":"-20 15","animation":_vm.animation,"variant":"link","no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{staticClass:"icon-menu3x3"})]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Test Dropdown Item")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1def7599","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/institution/components/InstitutionHeader.vue
// module id = null
// module chunks = 